import { Component, OnInit, ViewChild, TemplateRef, Output, EventEmitter } from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {HelpersService} from "../../../../services/tools/helpers.service";
import { CuentasPorCobrarService } from '../../../../services/cuentas-por-cobrar.service';

@Component({
  selector: 'app-modal-eliminar-contrato',
  templateUrl: './modal-eliminar-contrato.component.html',
  styleUrls: ['./modal-eliminar-contrato.component.scss']
})
export class ModalEliminarContratoComponent implements OnInit {

  public modal: any = null;
  public errors: any = {};
  
  //Modelos
  public contrato: any = {};

  //Helpers
  public eliminando: boolean = null;

  @ViewChild('modalEliminarContrato') private content: TemplateRef<any>;
  @Output() public contratoEliminada : EventEmitter<void> = new EventEmitter;

  constructor(private modalService: NgbModal,
    private helperService: HelpersService,
    private cuentasPorCobrarService: CuentasPorCobrarService) { }

  ngOnInit() {
  }

  public openModal(contrato: any){
    this.modal = this.modalService.open(this.content, { });
    this.contrato = contrato;
  }

  public closeModal() {
    this.modal.close();
  }

  public eliminarContrato(){
        this.eliminando = true;

        this.cuentasPorCobrarService.eliminarContrato(this.contrato.id_contrato).subscribe(
            (response)=>
            {
                this.eliminando = false;
                this.contratoEliminada.emit();
                this.modal.close();
                
                this.helperService.notification('Contrato eliminado', 'Se ha eliminado exitosamente el contrato', 'success');

            }, error =>
            {
                this.eliminando = false;
                // se resuelve error 403 y 500
                this.helperService.httpGlobalError(error);
                if(error.status == 400) {
                    alert("ERROR: "+JSON.stringify(error));
                }
            }
        );
  }

}



// WEBPACK FOOTER //
// ./src/app/components/contratos/listado/modal-eliminar-contrato/modal-eliminar-contrato.component.ts